// extracted by mini-css-extract-plugin
export default {"header":"MuseeFabreHeader_header__TkmgN","logo":"MuseeFabreHeader_logo__LSsrx"};